export default __webpack_public_path__ + "static/media/harmony-one-logo.5e03a35d.png";